import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { GeneralSetting } from '@apis'
import Table from '@components/table'
import Image from '@components/image'
import TableActions from '@components/table/actions'
import Column from '@components/column'
import { useNavigate } from 'react-router-dom'
import Alert from '@commons/popups/alert'
const BannerList = () => {
  const { data: banners } = useSelector((state: any) => state.banners)
  const navigate = useNavigate()
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const columns = [
    {
      title: 'Title',
      key: 'title',
      render: (item) => {
        const data = JSON.parse(item?.value)

        return data?.title
      },
    },
    {
      title: 'Banner Image',
      key: 'file',
      render: (item) => {
        return (
          <Image
            src={`${process.env.BUCKET_URL}/${item?.file}`}
            width={150}
            height={80}
          />
        )
      },
    },
    {
      title: 'Redirect Link',
      key: 'redirectLink',
      render: (item) => {
        const data = JSON.parse(item?.value)
        return data?.redirectLink
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item) => {
        return (
          <TableActions
            hasView={false}
            onClickEdit={() => {
              navigate(`/admin/settings/marketing-settings?tab=banners`, {
                state: item,
              })
            }}
            onClickDelete={() => {
              setDeleteInfo({
                visible: true,
                id: item?.id,
                loading: false,
              })
            }}
          />
        )
      },
    },
  ]
  const fetchData = async () => {
    await GeneralSetting.getByGroup({
      id: 'banners',
      state: 'banners',
    }).catch(() => {})
  }
  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await GeneralSetting.remove({
      id: deleteInfo?.id,
      state: 'banners',
    })
      .then(() => {
        navigate('/admin/settings/marketing-settings?tab=promos')
      })
      .catch(() => {})
    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }
  useEffect(() => {
    if (!banners?.length) {
      fetchData()
    }
  }, [])

  return (
    <Column styleColumn="margin-top:30px;">
      <Table columns={columns} data={banners} />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </Column>
  )
}

export default BannerList
